import { IAppState } from 'shared/common/state';

export const openedChatIdSelector = (state: IAppState): string | null => {
  return state.consultantCianChat.chatId;
};
